import UpdateZclousureCollection from "@/views/public/try_out/UpdateZclousureCollection.vue";

export default {
  path: "/try-out/update-zclousure",
  name: "UpdateZclousureCollections",
  component: UpdateZclousureCollection
};
